import classNames from "classnames";

export function InputTextarea({label, value, error, onChange = () => {}, disabled = false} : {label?: string, value?: string | undefined , error?: string | undefined, onChange?: (value: string) => void, disabled?: boolean}) {
    return (
        <div>
            {label && label?.length > 0 && (
                <label className="block mb-2 text-sm font-medium text-gray-900">{label}</label>
            )}
            <textarea
                className={
                    classNames(
                        "border text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-1 focus:border w-full p-2.5",
                        {
                            "bg-gray-50 border-gray-300 focus:border-blue-500 focus:ring-blue-500": !disabled && !error,
                            "bg-gray-50 border-red-500 focus:border-red-500 focus:ring-red-500": !disabled && error,
                            "bg-gray-200 border-gray-300 focus:border-blue-500 focus:ring-blue-500 cursor-not-allowed": disabled
                        },
                    )
                }
                value={value}
                onChange={(e) => onChange(e.target.value ?? "")}
                disabled={disabled}
                rows={4}
            />
            {error && (
                <p className="mt-1.5 text-xs text-red-600 dark:text-red-500">{error}</p>
            )}
        </div>
    );
}